/**
 * 首字母大写
 *
 * ```typescript
 * capitalize("fooBar"); // 'FooBar'
 * capitalize("fooBar", true); // 'Foobar'
 * ```
 */
var capitalize = function (str, lowerRest) {
    if (str === void 0) { str = ''; }
    if (lowerRest === void 0) { lowerRest = false; }
    return str.slice(0, 1).toUpperCase() +
        (lowerRest ? str.slice(1).toLowerCase() : str.slice(1));
};
export default capitalize;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2FwaXRhbGl6ZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb3JlL3V0aWxzL2xvZGFzaC9jYXBpdGFsaXplLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7O0dBT0c7QUFDSCxJQUFNLFVBQVUsR0FBRyxVQUFDLEdBQVEsRUFBRSxTQUFpQjtJQUEzQixvQkFBQSxFQUFBLFFBQVE7SUFBRSwwQkFBQSxFQUFBLGlCQUFpQjtJQUM3QyxPQUFBLEdBQUcsQ0FBQyxLQUFLLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDLFdBQVcsRUFBRTtRQUM3QixDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUMsR0FBRyxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQyxXQUFXLEVBQUUsQ0FBQyxDQUFDLENBQUMsR0FBRyxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQztBQUR2RCxDQUN1RCxDQUFDO0FBRTFELGVBQWUsVUFBVSxDQUFDIn0=